import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';

import {
  getHistoricsPagination,
  getHistoricsFilters,
  getHistoricsNeedFetch,
  getHistoricsIsLoading,
  getHistoricsIsSaving,
  getVisibleHistorics,
} from 'selectors/assets';

import { getCompany, getSubcompany } from 'auth/selectors';

import {
  getHistorics,
  acceptHistoric,
  rejectHistoric,
  setHistoricsPagination,
  setHistoricsFilters,
  resetHistoricsForm,
} from 'containers/assets/actions';

import { valueFromEvent } from 'lib/util';
import AssetsForm from 'components/assets/form_sections';
import AssetEditHistoricRow from 'containers/assets/edit_sections/AssetEditHistoricRow';

class AssetsEditHistoricsView extends Component {
  fetch = (filters, pagination) => {
    const { id, sid, aid } = this.props.match.params;
    this.props.getHistorics(
      aid,
      id,
      sid,
      filters,
      pagination.limit,
      pagination.page,
      pagination.orderBy,
      pagination.order
    );
  };

  fetchDebounced = debounce(this.fetch, 400);

  componentWillMount = () => this.fetch(this.props.filters, this.props.pagination);

  componentWillUnmount = () => this.props.reset();

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.needFetch && !isEqual(nextProps.pagination, this.props.pagination)) {
      this.fetch(nextProps.filters, nextProps.pagination);
    } else if (nextProps.needFetch && !isEqual(nextProps.filters, this.props.filters)) {
      this.fetchDebounced(nextProps.filters, nextProps.pagination);
    }
  };

  handleOrderChange = (orderBy, order) => this.props.setPagination({ orderBy, order });

  handleLimitChange = (limit) => this.props.setPagination({ limit: parseInt(limit, 10) });

  handlePageChange = (page) => this.props.setPagination({ page: parseInt(page, 10) });

  handleFiltersChange = (e) => this.props.setFilters(valueFromEvent(e));

  handleSubmit = () => this.fetch(this.props.pagination, this.props.filters);

  render = () => (
    <AssetsForm.Historics
      company={this.props.company}
      subcompany={this.props.subcompany}
      pagination={this.props.pagination}
      filters={this.props.filters}
      count={this.props.records.length}
      isLoading={this.props.isLoading}
      handleOrderChange={this.handleOrderChange}
      handleFiltersChange={this.handleFiltersChange}
      handleLimitChange={this.handleLimitChange}
      handlePageChange={this.handlePageChange}
      handleSubmit={this.handleSubmit}
    >
      {this.props.records.map((record) => (
        <AssetEditHistoricRow key={record.id} record={record} />
      ))}
    </AssetsForm.Historics>
  );
}

const mapStateToProps = (state) => ({
  pagination: getHistoricsPagination(state),
  filters: getHistoricsFilters(state),
  needFetch: getHistoricsNeedFetch(state),
  isLoading: getHistoricsIsLoading(state),
  isSaving: getHistoricsIsSaving(state),
  records: getVisibleHistorics(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});
const mapDispatchToProps = {
  getHistorics,
  setPagination: setHistoricsPagination,
  setFilters: setHistoricsFilters,
  accept: acceptHistoric,
  reject: rejectHistoric,
  reset: resetHistoricsForm,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetsEditHistoricsView));



// WEBPACK FOOTER //
// src/containers/assets/edit_sections/AssetsEditHistoricsSection.js